// Sentry must be initialized before any component renders so the router
// integration captures the initial page-load transaction.
import './instrument'

import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { reactErrorHandler } from '@sentry/react'

// @sentry/react's handler types componentStack as required, but react-dom's
// createRoot passes it as optional. Runtime is compatible; cast to match.
const sentryErrorHandler = reactErrorHandler() as unknown as (
  error: unknown,
  errorInfo: { componentStack?: string | undefined },
) => void

// Fontsource — self-hosted font imports (Fraunces serif, Inter sans)
import '@fontsource/fraunces/400.css'
import '@fontsource/fraunces/500.css'
import '@fontsource/fraunces/600.css'
import '@fontsource/fraunces/700.css'
import '@fontsource/inter/400.css'
import '@fontsource/inter/500.css'
import '@fontsource/inter/600.css'
import '@fontsource/inter/700.css'

import './app/globals.css'
import { App } from './app/app'
import { initializeTheme } from '@/lib/theme'

const root = document.getElementById('root')
if (!root) throw new Error('Root element not found')

initializeTheme()

createRoot(root, {
  onUncaughtError: sentryErrorHandler,
  onCaughtError: sentryErrorHandler,
  onRecoverableError: sentryErrorHandler,
}).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
